<template>
  <v-row justify="center">
    <v-dialog v-model="open" width="650px">
      <v-card dense>
        <v-toolbar elevation="0">
          <v-toolbar-title class="text--subtitle" style="padding-left: 10px">
            Remover <b>{{ toBeRemovedKeys.length }}</b>
            {{ isMultiple ? 'chave' : 'chaves' }}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn :disabled="isFetching" icon @click="handleClose()">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text class="px-7 py-0">
          <v-row no-gutters>
            <span>
              Você realmente deseja remover <b>{{ toBeRemovedKeys.length }}</b>
              {{ isMultiple ? 'chave' : 'chaves' }}, todos as chaves de acesso
              perderão suas conexões.
            </span>
          </v-row>
        </v-card-text>
        <v-card-actions class="px-7 pb-6">
          <v-spacer></v-spacer>
          <v-btn class="px-6" text @click="handleClose" :disabled="isFetching">
            {{ $t('message.cancel') }}
          </v-btn>
          <v-btn
            color="primary"
            :disabled="isFetching"
            :loading="isFetching"
            @click="handleRemove"
          >
            <span class="px-5">{{ $t('message.confirm') }}</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import drmApi from '@/services/drmApi'

export default {
  name: 'DrmRemoveMultipleKeys',
  components: {},
  data: () => ({
    open: false,
    isFetching: false,
    toBeRemovedKeys: [],
  }),
  computed: {
    isMultiple() {
      return this.toBeRemovedKeys.length < 2
    },
  },
  mounted() {
    this.$root.$on('drmRemoveMultipleKeysModal', (keys) => {
      Object.assign(this.$data, this.initialState())
      this.toBeRemovedKeys = keys
      this.open = true
    })
  },
  beforeDestroy() {
    this.$root.$off('removeMultipleModal')
  },
  methods: {
    async handleRemove() {
      this.isFetching = true
      let arr = []
      for (let key of this.toBeRemovedKeys) {
        arr.push({ id: key.id })
      }
      try {
        await drmApi.deleteMultipleDrmPrivateToken(arr)
        this.$root.$emit('removePrivateTokens', arr)
        this.handleClose()
      } catch (e) {
        console.log('e', e)
      }
      this.isFetching = false
    },
    handleClose() {
      this.open = false
    },
    initialState() {
      return {
        open: false,
        isFetching: false,
        toBeRemovedKeys: [],
      }
    },
  },
}
</script>

<style></style>
